import isEmpty from 'lodash-es/isEmpty';
import api from '../API';

export default class Helpers {
  /**
   * Are we on a device with touch support?
   * Checks all browsers and IE10/11 & Surface
   */
  static isTouchDevice = () => {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
  }

  /**
   * Check if an object is iterable
   */
  static isIterable (obj) {
    // checks for null and undefined
    if (obj == null) {
      return false;
    }

    return typeof obj[Symbol.iterator] === 'function';
  }

  /**
   * Url encode an object and prepeare for form data headers
   */
  static urlEncodeData (data) {
    if (isEmpty(data)) {
      return '';
    }

    const formBody = [];

    for (const property in data) {
      const encodedKey = encodeURIComponent(property);
      const encodedValue = encodeURIComponent(data[property]);
      formBody.push(encodedKey + '=' + encodedValue);
    }

    return formBody.join('&');
  }

  static gtmObituaryEvent (action = null, args = {}) {
    window.dataLayer = window.dataLayer || [];

    const eventAction = this.getGtmObituaryEventAction(action);

    const data = {
      event: 'memorial_page_kpi',
      eventCategory: 'Memorial Page KPI',
      eventAction
    };

    window.dataLayer.push({ ...data, ...args });
  }

  static getGtmObituaryEventAction (action = '') {
    let eventAction = '';

    switch (action) {
      case 'greeting':
        eventAction = 'Greeting';
        break;

      case 'donation':
        eventAction = 'Donation';
        break;

      case 'donationInitial':
        eventAction = 'Donation started';
        break;

      case 'donationStartedAfterGreeting':
        eventAction = 'Donation started after greeting';
        break;

      case 'image':
        eventAction = 'Greeting with media';
        break;

      case 'threadedComment':
        eventAction = 'Threaded comment';
        break;

      case 'like':
        eventAction = 'Like';
        break;

      case 'threadedLike':
        eventAction = 'Like, threaded comment';
        break;

      case 'share':
        eventAction = 'Shared page';
        break;

      case 'shareNative':
        eventAction = 'Shared page, native UI';
        break;

      default:
        eventAction = '';
        break;
    }

    return eventAction;
  }

  static obituaryGreetingsLog (action = null, memorialPageId = null, description = null) {
    let message = memorialPageId
      ? this.getObituaryGreetingsLogMessage(action) + ' Memorial page id: ' + memorialPageId
      : this.getObituaryGreetingsLogMessage(action);

    if (description) {
      message += ` - ${description}`;
    }

    return this.logToSlack(message, 'obituaryGreeting');
  }

  static logToSlack (message, logType = 'default') {
    const url = 'log-to-slack';

    return api.post(url, { message, logType });
  }

  static getObituaryGreetingsLogMessage (action = '') {
    const messages = {
      donationInitial: '*Flow started*. Donation is first step.',
      greetingInitial: '*Flow started*. Greeting is first step.',
      donationQuery: '*Donation query.*',
      greetingQuery: '*Greeting query.*',
      publishGreetingAndDonationQuery: '*Publish greeting and donation query.*',
      donationStartedAfterGreeting: '*Donation started after greeting.*',
      donation: '*Donated.* :tada:',
      greetingAfterDonation: '*Greeting after donation.*',
      donatedClosedWithoutGreeting: '*Flow cancelled*. Donated and left no greeting.',
      donationCancelledAfterWarning: '*Flow cancelled*. Donation cancelled after warning.',
      closeWarningHasFiles: '*Flow cancelled*. Files had been uploaded but greeting was not submitted.',
      closeWarningHasMessage: '*Flow cancelled*. Greeting was written but not sumbitted.',
      donationError: '*Donation error.*',
      imageError: '*Image upload error.*',
      imageRestrictionError: '*Image upload error.* Restriction.',
      publishedGreeting: '*Published greeting.* :tada:'
    };

    return messages[action];
  }

  static gtmContactFormOpenEvent (formLocation) {
    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
      event: 'contact_form_open',
      eventCategory: 'Kontaktformulär',
      eventAction: 'Öppna kontakformulär',
      formLocation,
    });
  }
}
